import * as constants from "../constants/constants";

// --- New typed interfaces ---
export interface InstallationStats {
    waiting: number;
    overdue: number;
    inProgress: number;
    blocked: number;
    partial: number;
    completed: number;
    withoutInstallationWaiting: number;
}

export interface Pagination {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
}

export interface InstallationState {
    // New state
    stats: InstallationStats | null;
    installations: any[];
    installationsPagination: Pagination;
    installationsTotal: number;
    installationsCities: any[];
    currentInstallation: any | null;
    waitingItems: any[];
    waitingPagination: Pagination;
    waitingTotal: number;
    waitingCities: any[];
    withoutInstallationItems: any[];
    withoutInstallationPagination: Pagination;
    locations: any[];
    // Legacy state
    installationRecords: any;
    installationRecordsPagination: any;
    installationRecordsGrandTotal: number;
    installationRecordByProjectId: any;
    installationRecordsForMap: any;
    projectsForInstallation: any;
    installationRecordByTransportId: any;
}

const defaultPagination: Pagination = { currentPage: 1, lastPage: 1, perPage: 20, total: 0 };

const parsePagination = (meta: any): Pagination => {
    if (!meta) return { ...defaultPagination };
    return {
        currentPage: Number(meta.current_page) || 1,
        lastPage: Number(meta.last_page) || 1,
        perPage: Number(meta.per_page) || 20,
        total: Number(meta.total) || 0,
    };
};

const initialState = (): InstallationState => {
    return {
        // New
        stats: null,
        installations: [],
        installationsPagination: { ...defaultPagination },
        installationsTotal: 0,
        installationsCities: [],
        currentInstallation: null,
        waitingItems: [],
        waitingPagination: { ...defaultPagination },
        waitingTotal: 0,
        waitingCities: [],
        withoutInstallationItems: [],
        withoutInstallationPagination: { ...defaultPagination },
        locations: [],
        // Legacy
        installationRecords: [],
        installationRecordsPagination: { ...defaultPagination },
        installationRecordsGrandTotal: 0,
        installationRecordByProjectId: {},
        installationRecordsForMap: [],
        projectsForInstallation: [],
        installationRecordByTransportId: {},
    };
};

const installation = (state: InstallationState = initialState(), action: any) => {
    switch (action.type) {
        // --- New actions ---

        case constants.FETCH_INSTALLATION_DASHBOARD_STATS_NEW:
            return { ...state, stats: action.payload };

        case constants.FETCH_INSTALLATIONS_NEW:
            return {
                ...state,
                installations: action.payload.data || [],
                installationsPagination: parsePagination(action.payload.meta),
                installationsTotal: action.payload.totalValue ?? 0,
                installationsCities: action.payload.cities ?? [],
            };

        case constants.FETCH_INSTALLATION_NEW:
            return { ...state, currentInstallation: action.payload };

        case constants.FETCH_INSTALLATION_WAITING_NEW:
            return {
                ...state,
                waitingItems: action.payload.data || [],
                waitingPagination: parsePagination(action.payload.meta),
                waitingTotal: action.payload.totalValue ?? 0,
                waitingCities: action.payload.cities ?? [],
            };

        case constants.FETCH_INSTALLATION_LOCATIONS_NEW:
            return { ...state, locations: action.payload || [] };

        case constants.FETCH_WITHOUT_INSTALLATION: {
            const data = action.payload;
            return {
                ...state,
                withoutInstallationItems: data?.data || [],
                withoutInstallationPagination: data?.meta ? parsePagination(data.meta) : (data?.last_page ? parsePagination(data) : { ...defaultPagination, total: (data?.data || []).length }),
            };
        }

        // --- Legacy actions ---

        case constants.FETCH_INSTALLATION_RECORDS:
            return {
                ...state,
                installationRecords: action.payload.data || action.payload,
                installationRecordsPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0,
                } : state.installationRecordsPagination,
                installationRecordsGrandTotal: action.payload.grandTotal || 0,
            };

        case constants.FETCH_INSTALLATION_RECORD_BY_PROJECT_ID:
            return { ...state, installationRecordByProjectId: action.payload };

        case constants.FETCH_INSTALLATION_RECORD_BY_TRANSPORT_ID:
            return { ...state, installationRecordByTransportId: action.payload };

        case constants.FETCH_INSTALLATION_RECORDS_FOR_MAP:
            return { ...state, installationRecordsForMap: action.payload };

        case constants.FETCH_PROJECTS_FOR_INSTALLATION:
            return { ...state, projectsForInstallation: action.payload };
    }

    return state;
};

export default installation;
